import { createRouter, createWebHashHistory } from 'vue-router';
import { useStore } from '@/store/store';
import AXIOS from '@/features/axios.js';
import utils from '@/features/utils.js';
import API from '@/constants/api.constants';

const routes = [
  {
    path: '/',
    component: () => import( '@/components/views/HomeView.vue' ),
    children: [
      {
        path: '',
        redirect: '/dashboard'
      },
      {
        path: 'dashboard',
        component: () => import( '@/components/views/DashboardView.vue' )
      },
      {
        path: 'board',
        component: () => import( '@/components/views/BoardView.vue' )
      },
      {
        path: 'settings',
        component: () => import( '@/components/views/SettingsView.vue' )
      },
      {
        path: '/rp/:id',
        component: () => import( '@/components/views/RPView.vue' )
      },
      {
        path: '/management',
        component: () => import( '@/components/views/ManagementView.vue' )
      },
      {
        path: '/sticky_notes/:id/:type',
        component: () => import( '@/components/views/StickyNotesView.vue' )
      },
      {
        path: '/charts/:id',
        component: () => import( '@/components/views/RPChartsView.vue' )
      }
    ]
  },
  {
    path: '/404',
    component: () => import( '@/components/views/404View.vue' )
  },
  {
    path: '/login',
    component: () => import( '@/components/views/SignInView.vue' )
  }
];

const router = createRouter( {
  history: createWebHashHistory(),
  routes
} );

router.beforeEach( ( to, from, next ) => {

  if ( to.path === '/404' ) {
    return next();
  }

  const url_params = new URLSearchParams( window.location.search );
  const user_id = url_params.get( 'flashmeeting-user-id' );

  if ( user_id ) {
    AXIOS.get( API.get_api( API.API_NAMES.AUTH_IS_FM_USER_SIGN_IN ), { params: { 'user-id': user_id } } )
      .then( ( response ) => {
        if ( response.status === 200 ) {
          if ( utils.isTrue( response.data.signin ) ) {
            window.location = window.location.origin;
          } else {
            return next( {
              path: '/404',
              query: { returnUrl: to.path }
            } );
          }
        } else {
          return next( {
            path: '/404',
            query: { returnUrl: to.path }
          } );
        }
        utils.showAxiosError( response );
      } )
      .catch( () => {
        return next( {
          path: '/404',
          query: { returnUrl: to.path }
        } );
      } );
  } else {
    let store = useStore();

    AXIOS.get( API.get_api( API.API_NAMES.AUTH_IS_SIGN_IN_WEB ) )
      .then( ( response ) => {
        if ( response.status === 200 ) {
          if ( utils.isTrue( response.data.signin ) ) {

            AXIOS.get( API.get_api( API.API_NAMES.USERS, response.data.id ), { headers: { 'auth-token': response.headers[ 'auth-token' ] } } )
              .then( ( user ) => {
                store.setConnected( { connect: true, connect_user: user.data, token: user.headers[ 'auth-token' ] } );
                if ( to.path === '/login' || to.path === '/resetpwd' || to.path === '/coderesetpwd' || to.path === '/changepwd' ) {
                  return next( {
                    path: '/',
                    query: { returnUrl: to.path }
                  } );
                } else {
                  return next();
                }
              } )
              .catch( () => {
                return next( {
                  path: '/404',
                  query: { returnUrl: to.path }
                } );
              } );
          } else {
            store.setAuthFlashmeeting( { url: response.data.url, automatic: response.data.automatic } );
            if ( !response.data.url || response.data.url && response.data.automatic === 'false' ) {
              if ( to.path !== '/login' && to.path !== '/resetpwd' && to.path !== '/coderesetpwd' || to.path === '/changepwd' ) {
                return next( {
                  path: '/login',
                  query: { returnUrl: to.path }
                } );
              } else {
                return next();
              }
            } else {
              window.location = response.data.url;
            }
          }
        } else {
          return next( {
            path: '/404',
            query: { returnUrl: to.path }
          } );
        }
        utils.showAxiosError( response );
      } )
      .catch( ( err ) => {
        if ( err.response && err.response.status == 406 ) {
          store.setAuthFlashmeeting( { url: err.response.data.url, automatic: err.response.data.automatic } );
            if ( !err.response.data.url || err.response.data.url && err.response.data.automatic === 'false' ) {
              if ( to.path !== '/login' && to.path !== '/resetpwd' && to.path !== '/coderesetpwd' || to.path === '/changepwd' ) {
                return next( {
                  path: '/login',
                  query: { returnUrl: to.path }
                } );
              } else {
                return next();
              }
            } else {
              window.location = err.response.data.url;
            }
        } else {
          return next( {
            path: '/404',
            query: { returnUrl: to.path }
          } );
        }
      } );
    }
} );

export default router;
